var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgIconSubjectsData = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8.30005L12.8 8.60005C12 8.70005 11.3 8.10005 11.2 7.30005L11 4.80005H11.1L15.3 8.30005Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 17.6C16.3 18.4 15.7 19.1 14.9 19.2L7.09999 20H6.99999H6.79999C5.99999 20.1 5.29999 19.5 5.19999 18.7L3.99999 6.89995C3.89999 6.09995 4.49999 5.39995 5.29999 5.29995L10.9 4.69995H11L11.2 7.09995C11.2 7.29995 11.3 7.49995 11.4 7.59995C11.5 7.99995 11.6 8.09995 11.7 8.19995C12 8.49995 12.4 8.59995 12.8 8.59995H13H13.1L15.3 8.39995L16.2 17.6Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.30005L15.5 8.40005H15.4L13.5 8.60005C13.4 8.60005 13.3 8.60005 13.3 8.60005C12.5 8.50005 11.9 8.00005 11.9 7.30005L11.7 5.30005V5.20005V4.80005H11.8L16 8.30005Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 17.6C16.3 18.4 15.7 19.1 14.9 19.2L7.1 20C6.4 19.9 5.9 19.4 5.8 18.7L4.6 6.90005C4.5 6.10005 5.1 5.40005 5.9 5.30005L10.9 4.80005H11H11.1H11.5H11.6V5.20005V5.30005L11.8 7.20005C11.9 8.00005 12.5 8.50005 13.2 8.60005C13.3 8.60005 13.4 8.60005 13.4 8.60005L15.3 8.40005L16.2 17.6Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.3H17.3C16.4 8.3 15.7 7.6 15.7 6.7V4L15.8 4.1L20 8.3Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.3V18.4C20 19.3 19.3 20 18.4 20H9.49999C8.59999 20 7.89999 19.3 7.89999 18.4V5.6C7.89999 4.7 8.59999 4 9.49999 4H15.6H15.7V6.7C15.7 7.6 16.4 8.3 17.3 8.3H20Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.3V18.4C20 19.3 19.3 20 18.4 20H10.3C9.4 20 8.7 19.3 8.7 18.4V5.6C8.7 4.7 9.4 4 10.3 4H15.6H15.7V6.7C15.7 7.6 16.4 8.3 17.3 8.3H20Z",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.008,
    y1: 8.62856,
    x2: 12.918,
    y2: 6.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.7954,
    y1: 11.416,
    x2: 7.42959,
    y2: 12.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.8075,
    y1: 3.67865,
    x2: 7.8177,
    y2: 14.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 17.0109,
    y1: 5.56955,
    x2: 5.6912,
    y2: 17.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.1162,
    y1: 4.08339,
    x2: 16.9893,
    y2: 7.5396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 18.3338,
    y1: 12.205,
    x2: 2.38749,
    y2: 11.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 11.2055,
    y1: -2.8415,
    x2: 15.6247,
    y2: 20.1581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSubjectsData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconSubjectsData.530c4165.svg";
export { ForwardRef as ReactComponent };